<template>
  <div>
    <b-form-group label="技"
      description="ダイスショットで使用する技。成功するとダイス値に選択したステータスが加算されます。"
    >
      <b-form-select v-model="form.use"
        :options="[
          { value:'STR', text:'【STR】力押し' },
          { value:'INT', text:'【INT】頭を使う' },
          { value:'VIT', text:'【VIT】我慢する' },
          { value:'MND', text:'【MND】説得する' },
          { value:'DEX', text:'【DEX】急所を狙う' },
          { value:'AGI', text:'【AGI】うまいことやる' },
        ]"
        @input="$emit('input', form)"
      />
    </b-form-group>
    <b-form-group label="見切り"
      description="ダイスショットで封殺する技。相手の技に一致すると失敗させることができます。"
    >
      <b-form-select v-model="form.block"
        :options="[
          { value:'STR', text:'【STR】力押し' },
          { value:'INT', text:'【INT】頭を使う' },
          { value:'VIT', text:'【VIT】我慢する' },
          { value:'MND', text:'【MND】説得する' },
          { value:'DEX', text:'【DEX】急所を狙う' },
          { value:'AGI', text:'【AGI】うまいことやる' },
        ]"
        @input="$emit('input', form)"
      />
    </b-form-group>
  </div>
</template>

<script>
export default {
  name: 'dice-shot',
  props: {
    option: Object
  },
  data () {
    return {
      form: this.option
    }
  }
}
</script>
